export default __webpack_public_path__ + "static/media/operationModes.617eacf9.svg";